import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withKeys as _withKeys, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15ec1d6f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-select-wrapper" }
const _hoisted_2 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_select_text = _resolveComponent("oxd-select-text")!
  const _component_oxd_select_option = _resolveComponent("oxd-select-option")!
  const _component_oxd_select_dropdown = _resolveComponent("oxd-select-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_oxd_select_text, _mergeProps(_ctx.$attrs, {
      value: _ctx.inputValue,
      disabled: _ctx.disabled,
      onBlur: _ctx.onBlur,
      onFocus: _ctx.onOpenDropdown,
      onKeyup: _withKeys(_ctx.onCloseDropdown, ["esc"]),
      onKeydown: [
        _withKeys(_withModifiers(_ctx.onSelectEnter, ["prevent"]), ["enter"]),
        _withKeys(_withModifiers(_ctx.onSelectDown, ["exact","prevent"]), ["down"]),
        _withKeys(_withModifiers(_ctx.onSelectUp, ["exact","prevent"]), ["up"]),
        _ctx.onKeypress
      ]
    }), {
      afterInput: _withCtx(() => [
        (_ctx.modelValue)
          ? _renderSlot(_ctx.$slots, "afterSelected", {
              key: 0,
              data: _ctx.modelValue
            }, undefined, true)
          : _createCommentVNode("", true)
      ]),
      _: 3
    }, 16, ["value", "disabled", "onBlur", "onFocus", "onKeyup", "onKeydown"]),
    (_ctx.dropdownOpen)
      ? (_openBlock(), _createBlock(_component_oxd_select_dropdown, {
          key: 0,
          class: _normalizeClass(_ctx.dropdownClasses),
          loading: _ctx.loading,
          empty: _ctx.computedOptions.length === 0,
          "empty-text": _ctx.emptyText
        }, {
          default: _withCtx(() => [
            (_ctx.showEmptySelector)
              ? (_openBlock(), _createBlock(_component_oxd_select_option, {
                  key: 0,
                  onSelect: _ctx.onClear
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.placeholderText), 1)
                  ]),
                  _: 1
                }, 8, ["onSelect"]))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.computedOptions, (option, i) => {
              return (_openBlock(), _createBlock(_component_oxd_select_option, {
                key: option.id,
                class: _normalizeClass(_ctx.optionClasses[i]),
                disabled: option._disabled || option._selected,
                ref_for: true,
                ref: `option-${i}`,
                onSelect: ($event: any) => (_ctx.onSelect(option))
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "option", { data: option }, undefined, true),
                  (!_ctx.$slots['option'])
                    ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(option.label), 1))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1032, ["class", "disabled", "onSelect"]))
            }), 128))
          ]),
          _: 3
        }, 8, ["class", "loading", "empty", "empty-text"]))
      : _createCommentVNode("", true)
  ]))
}